import { isBefore, today } from '@perch-labs/warbler';

export const WAITLISTED_VNM_STATUSES = ['waitlist', 'pending', 'allocated'];

export const isWaitlist = (status: string): boolean =>
  WAITLISTED_VNM_STATUSES.includes(status);

const PAST_DUE_PRODUCT_STATUSES = ['pending', 'available', 'ineligible'];

export const isPastDue = (status: string): boolean =>
  PAST_DUE_PRODUCT_STATUSES.includes(status);

export const vnmStatuses = {
  enrolled: 'enrolled',
  waitlist: 'waitlist',
};

export const vnmExplainerGuide =
  'https://www.arcadia.com/article/what-is-community-solar';
export const vnmExplainerBlog =
  'https://blog.arcadia.com/new-climate-advocacy-tool/';

export const SAMPLE_ZIPCODE = '12345';

export const PAST_DUE_ASSISTANCE_AMOUNT = 200;

export const isCredit = (amount: number): boolean => amount < 0;
export const getPercentToSolarFarm = (percentSavings: number): number =>
  100 - percentSavings;

export const graphDataExists = (obj: Record<string, unknown>): boolean =>
  !!obj && Object.values(obj).some(value => Boolean(value));

export const projectIsLive = (startDate?: Date): boolean | undefined =>
  startDate && isBefore(startDate, today());
